import React, { useMemo, useState } from 'react';
import { Search, Check } from 'lucide-react';
import { formatCNPJ, formatCodigoCliente } from '../../utils/format';
import { filtrarClientes } from '../../utils/buscaCliente';
import '../css/seletorClienteModal.css';

/**
 * Modal de seleção de cliente exibido exclusivamente no momento do login, quando o
 * usuário possui mais de um cliente vinculado (escolha obrigatória, sem botão de fechar).
 * Depois do login, a troca de cliente continua pelo dropdown do cabeçalho (cabecalho.js),
 * que não usa este componente.
 */
function SeletorClienteModal({ clientesPerfis, cdClienteAtivo, onSelecionar, onFechar }) {
    const [busca, setBusca] = useState('');

    const clientesFiltrados = useMemo(() => filtrarClientes(clientesPerfis, busca), [busca, clientesPerfis]);

    return (
        <div className="modal seletor-cliente-modal-overlay">
            <div className="modal-content seletor-cliente-modal-content">
                {onFechar && (
                    <button className="modal-close" onClick={onFechar} aria-label="Fechar">✖</button>
                )}

                <h3>Selecione o cliente</h3>
                <p className="seletor-cliente-modal-subtitulo">
                    Escolha qual cliente você quer acessar.
                </p>

                <div className="seletor-cliente-modal-busca">
                    <Search size={18} />
                    <input
                        type="text"
                        placeholder="Buscar por nome, código ou CNPJ..."
                        value={busca}
                        onChange={(event) => setBusca(event.target.value)}
                        autoFocus
                    />
                </div>

                <div className="seletor-cliente-modal-contagem">
                    {clientesFiltrados.length} de {clientesPerfis.length} clientes
                </div>

                <div className="seletor-cliente-modal-lista">
                    {clientesFiltrados.length === 0 && (
                        <p className="seletor-cliente-modal-vazio">Nenhum cliente encontrado para "{busca}".</p>
                    )}
                    {clientesFiltrados.map((item) => {
                        const ativo = String(item.cdCliente) === String(cdClienteAtivo);
                        return (
                            <button
                                key={item.cdCliente}
                                className={`seletor-cliente-modal-item ${ativo ? 'is-ativo' : ''}`}
                                onClick={() => onSelecionar(item.cdCliente)}
                            >
                                <span className="seletor-cliente-modal-codigo">{formatCodigoCliente(item.cdCliente, item.digitoCliente)}</span>
                                <span className="seletor-cliente-modal-info">
                                    <strong>{item.nmCliente}</strong>
                                    <small>{formatCNPJ(item.dsCnpjCpf)}</small>
                                </span>
                                {ativo && <Check size={18} className="seletor-cliente-modal-check" />}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default SeletorClienteModal;
